import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export const FAQ = () => {
  const objections = [{
    q: '¿Sirve si recién empiezo a jugar al rugby?',
    a: 'Sí. El sistema está diseñado por capítulos progresivos. Si recién empezás, vas a poder asentar las bases físicas y técnicas correctas desde el primer día. Si ya jugás hace años, vas a encontrar los detalles que te faltan para romper tu meseta.'
  }, {
    q: 'No tengo tiempo para entrenar todos los días, ¿igual me sirve?',
    a: 'Totalmente. El sistema incluye organización del entrenamiento semanal y rutinas adaptables a 2, 3 o 4 estímulos por semana. Lo importante no es entrenar mucho, sino entrenar bien y específico para tu posición.'
  }, {
    q: 'No juego de forward / no juego de back, ¿igual lo aprovecho?',
    a: 'Sí. Hay capítulos y bonos específicos para cada posición (Wings, Fullbacks, Centros, Aperturas, Medioscrum, Segundas Líneas, Pilares y Hookers). Vas directo a lo que necesitás según tu puesto.'
  }, {
    q: '¿Necesito gimnasio o equipamiento caro?',
    a: 'No. Las rutinas están pensadas para adaptarse a gimnasio completo, gimnasio básico o entrenamiento con poco equipamiento. Lo que cambia es la selección de ejercicios, no la efectividad del sistema.'
  }, {
    q: '¿Cómo recibo el material después de pagar?',
    a: 'Una vez confirmado el pago, recibís todo el material en PDF de manera inmediata al email que uses en la compra. Acceso de por vida, sin suscripciones ni pagos recurrentes.'
  }, {
    q: '¿Y si no me sirve?',
    a: 'El sistema está diseñado en base a las exigencias reales del rugby moderno y aplica para cualquier jugador que quiera mejorar su rendimiento. Si seguís el plan y aplicás los conceptos, los resultados llegan. Miles de jugadores ya lo están aplicando.'
  }, {
    q: '¿Es un pago único o tiene mensualidades?',
    a: 'Es un pago único. Pagás una sola vez y tenés acceso de por vida a todo el sistema, los 4 bonos estratégicos y los bonos extra de regalo. Sin cargos ocultos.'
  }, {
    q: '¿Puedo pagar con tarjeta argentina o Mercado Pago?',
    a: 'Sí. El checkout acepta tarjetas de crédito y débito argentinas, Mercado Pago y diferentes medios de pago seguros. El proceso de compra está 100% encriptado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-16 px-4 bg-zinc-950 border-t border-zinc-900" data-id="element-114">
      <div className="max-w-3xl mx-auto" data-id="element-115">
        <div className="text-center mb-10" data-id="element-116">
          <div className="inline-flex items-center justify-center gap-2 bg-lime-500/10 text-lime-400 px-3 py-1 rounded-full font-bold text-xs mb-4 border border-lime-500/20" data-id="element-117">
            <HelpCircle className="w-3.5 h-3.5" data-id="element-118" />
            <span data-id="element-119">PREGUNTAS FRECUENTES</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold uppercase tracking-tight mb-3 font-oswald text-white" data-id="element-120">
            ¿TENÉS <span className="text-lime-400" data-id="element-121">DUDAS</span>? ACÁ LAS
            RESPONDEMOS
          </h2>
          <p className="text-sm md:text-base text-zinc-400" data-id="element-122">
            Las consultas más comunes antes de empezar.
          </p>
        </div>

        <div className="space-y-3" data-id="element-123">
          {objections.map((item, idx) => <div key={idx} className={`rounded-xl border transition-colors ${openIndex === idx ? 'border-lime-500/50 bg-zinc-900/60' : 'border-zinc-800 bg-zinc-900/30 hover:border-zinc-700'}`} data-id="element-124">
              <button type="button" onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-5 py-4 flex items-center justify-between text-left gap-4" data-id="element-125">
                <span className={`font-bold text-sm md:text-base ${openIndex === idx ? 'text-white' : 'text-zinc-200'}`} data-id="element-126">
                  {item.q}
                </span>
                <ChevronDown className={`w-5 h-5 shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180 text-lime-400' : 'text-zinc-500'}`} data-id="element-127" />
              </button>

              <AnimatePresence data-id="element-128">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} className="overflow-hidden" data-id="element-129">
                    <div className="px-5 pb-4 text-sm md:text-base text-zinc-400 leading-relaxed" data-id="element-130">
                      {item.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};